import React from "react";
import { ListItem, ListItemText, Typography } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import { OuterList, InnerList, useFilterListStyles } from "pages/CreativeMappings/components";
import { FilterViewModel } from "api/factories/ulits.factory";

interface FiltersListProps {
    filters: FilterViewModel[];
}

export const FiltersList = ({ filters }: FiltersListProps) => {
    // TODO: wrap with styled components when possible
    const classes = useFilterListStyles();

    return (
        <OuterList flex={4} disablePadding={true}>
            {filters.map(({ translation, operator, options, logicalOperator }, index) => {
                return (
                    <ListItem className={classes.row} key={index}>
                        <InnerList key={index}>
                            <ListItem divider={true} className={classes.smallListItem}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">{translation}</Typography>
                                </ListItemText>
                            </ListItem>
                            <ListItem divider={true} className={classes.smallListItem}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">{operator}</Typography>
                                </ListItemText>
                            </ListItem>
                            <ListItem divider={true} className={classes.mediumListItem}>
                                <ListItemText disableTypography={true} className={classes.chipContainer}>
                                    {options?.map(({ name }) => (
                                        <Chip key={`${name}_${index}`} label={name} className={classes.chip} />
                                    ))}
                                </ListItemText>
                            </ListItem>
                            <ListItem divider={true} className={classes.smallListItem}>
                                <ListItemText disableTypography={true}>
                                    <Typography variant="subtitle1">{logicalOperator}</Typography>
                                </ListItemText>
                            </ListItem>
                        </InnerList>
                    </ListItem>
                );
            })}
        </OuterList>
    );
};
